import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import config from './config.js';
import * as Sentry from '@sentry/angular';


if (config.environment_name !== 'local') {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    environment: config.environment_name,
    release: 'translate-quotes@' + config.application_version,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
    tracePropagationTargets: [
      /^https:\/\/translate-quotes(-[a-z]+)?\.nprd-astrazeneca\.com/,
    ],
  });
}

if (config.MATOMO_SITE_ID) {
  const _paq = ((window as any)._paq = (window as any)._paq || []);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  const u = 'https://analytics.astrazeneca.com/';
  _paq.push(['setTrackerUrl', u + 'matomo.php']);
  _paq.push(['setSiteId', config.MATOMO_SITE_ID]);
  const g = document.createElement('script');
  const s = document.getElementsByTagName('script')[0];
  g.async = true;
  g.src = u + 'matomo.js';
  s.parentNode!.insertBefore(g, s);
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);

const domain = config.AWS_COGNITO_CLIENT_DOMAIN;

const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: config.AWS_COGNITO_CLIENT_ID,
      userPoolId: config.AWS_COGNITO_USER_POOL_ID,
      identityPoolId: config.AWS_COGNITO_IDENTITY_POOL_ID, // REQUIRED - Amazon Cognito Identity Pool ID
      loginWith: {
        oauth: {
          domain,
          scopes: ['openid', 'email', 'profile', config.COGNITO_SCOPE],
          redirectSignIn: [
            `${config.APP_DOMAIN_ENDPOINT}/auth/callback`,
            'http://localhost:4200/auth/callback',
          ],
          redirectSignOut: [
            `${config.APP_DOMAIN_ENDPOINT}/auth/login`,
            'http://localhost:4200/auth/login',
          ],
          responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
};
Amplify.configure(awsConfig);
